import { Newspaper } from "lucide-react";

export const ArticlePlaceholder = ({ className = "" }) => {
  return (
    <div 
      className={`bg-gradient-to-br from-slate-800 to-slate-900 flex items-center justify-center ${className}`}
    >
      <div className="text-center">
        <div className="w-16 h-16 border border-amber-400/30 flex items-center justify-center mx-auto mb-3">
          <Newspaper className="w-8 h-8 text-amber-400/50" />
        </div>
        <p className="text-amber-400/40 text-xs uppercase tracking-widest">Unleashed Ventures</p>
      </div>
    </div>
  );
};
